import { msg } from '@lingui/core/macro';
import { CarouselPlaceholder } from 'modules/overlay-canvas/types/placeholders/create-argument';
import type { MessageDescriptor } from 'shared/i18n/i18n';

interface IItem extends CarouselPlaceholder {
  /** Подпись кнопки в меню. `blockText` — текст объекта на канве, он сохраняется в табло и не переводится. */
  listName: MessageDescriptor;
}

export const carouselPlaceholderList: IItem[] = [
  {
    blockText: 'Аватар игрока',
    listName: msg`Аватар`,
    type: 'image',
    indicator: 'carousel-avatar',
    teamIndex: 0,
  },
  {
    blockText: 'ФИО игрока',
    listName: msg`ФИО`,
    type: 'text',
    indicator: 'carousel-name',
    teamIndex: 0,
  },
  {
    blockText: 'Номер игрока',
    listName: msg`Номер`,
    type: 'text',
    indicator: 'carousel-number',
    teamIndex: 0,
  },
  {
    blockText: 'Позиция игрока',
    listName: msg`Позиция`,
    type: 'text',
    indicator: 'carousel-position',
    teamIndex: 0,
  },
];
